export enum ENV_LIST {
    LOCAL = 'local',
    STAGING = 'staging',
    REVIEW_APP = 'review_app',
    DEMO_01 = 'demo01',
    SANDBOX = 'sandbox',
    PRODUCTION = 'production',
}

export enum AvailableToggleFeatures {
    kits = 'kits',
}

const featuresByEnv = Object.freeze({
    // Usage example:
    // [ENV_LIST.LOCAL]: [AvailableToggleFeatures.ma_feature]
    [ENV_LIST.LOCAL]: [AvailableToggleFeatures.kits],
    [ENV_LIST.STAGING]: [AvailableToggleFeatures.kits],
    [ENV_LIST.REVIEW_APP]: [AvailableToggleFeatures.kits],
    [ENV_LIST.DEMO_01]: [],
    [ENV_LIST.SANDBOX]: [],
    [ENV_LIST.PRODUCTION]: [],
});

export function getEnabledFeaturesByEnv(envName: ENV_LIST) {
    return featuresByEnv?.[envName];
}
